<template>
    <div class="account-locked">
        <h2>Account locked</h2>

        <Alert type="danger" message="Your account has been locked. Please contact your administrator to resolve the issue." />

        <a class="btn btn-danger" href="/site/logout">Log out</a>
    </div>
</template>

<script>
import Alert from "@/components/Alert";
export default {
    name: "AccountLocked",
    components: {Alert},
}
</script>

<style scoped lang="scss">
.account-locked {
    h2 {
        padding-bottom: 20px;
    }
}
</style>